var _path, _path2, _g, _path3, _path4, _path5, _g2, _path6, _path7, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 125,
    viewBox: "0 0 205 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_43_3926",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 47,
    width: 177,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6491 47.9972H190.439V77.9412H14.6491V47.9972Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_43_3926)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_43_3926",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 47,
    width: 177,
    height: 31
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6491 77.9412H190.439V47.9972H14.6491V77.9412Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_43_3926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.5846 51.2745C83.5846 50.5633 83.866 49.8812 84.367 49.3783C84.8679 48.8754 85.5475 48.5929 86.2559 48.5929C86.9644 48.5929 87.6438 48.8754 88.1447 49.3783C88.6457 49.8812 88.9271 50.5633 88.9271 51.2745C88.9013 51.9684 88.6086 52.6252 88.1104 53.1069C87.6123 53.5887 86.9476 53.8578 86.2559 53.8578C85.5642 53.8578 84.8994 53.5887 84.4013 53.1069C83.9031 52.6252 83.6104 51.9684 83.5846 51.2745Z",
    fill: "#273B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.731 69.1587C125.731 67.6704 126.926 66.4697 128.397 66.4697C128.927 66.4671 129.446 66.6226 129.889 66.9165C130.331 67.2104 130.676 67.6294 130.881 68.1206C131.086 68.6117 131.141 69.1528 131.039 69.6753C130.937 70.1978 130.683 70.6781 130.309 71.0555C129.935 71.4329 129.457 71.6903 128.937 71.7951C128.417 71.9 127.878 71.8475 127.388 71.6443C126.898 71.4412 126.479 71.0965 126.184 70.6541C125.889 70.2116 125.731 69.6911 125.731 69.1587Z",
    fill: "#499FDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7618 67.9954C37.4626 67.9954 35.8628 66.1616 35.8628 63.5397C35.8628 60.9179 37.4626 59.0878 39.7637 59.0878C42.0759 59.0878 43.6924 60.9179 43.6924 63.5397C43.6924 66.2026 42.1113 67.9954 39.7618 67.9954ZM39.7618 55.1718C34.8955 55.1718 31.363 58.6919 31.363 63.5378C31.363 68.3838 34.8974 71.9039 39.7618 71.9039C44.6486 71.9039 48.1942 68.3857 48.1942 63.5378C48.1942 58.69 44.6486 55.1681 39.7637 55.1681M78.4281 63.9561C78.2588 63.6273 78.0446 63.3237 77.7918 63.0542L77.6431 62.8992L77.7993 62.7498C78.0448 62.4883 78.2687 62.2073 78.469 61.9095L82.7474 55.5005H77.5315L74.3039 60.5145C74.1216 60.7834 73.7534 60.9179 73.2009 60.9179H72.4661V51.4389C72.4661 49.5435 71.2886 49.2857 70.0181 49.2857H67.8416L67.8473 71.6574H72.4679V64.9459H72.9014C73.4279 64.9459 73.7851 65.0075 73.9506 65.2951L76.4991 70.1242C77.2116 71.4351 77.9203 71.6555 79.2559 71.6555H82.7958L80.1581 67.2783L78.4095 63.9543M100.838 55.1289C98.4867 55.1289 96.9873 56.1784 96.1465 57.0654L95.8675 57.3492L95.7671 56.9627C95.5215 56.0103 94.6882 55.4912 93.4362 55.4912H91.3659L91.3788 71.6499H95.968V64.2026C95.968 63.4744 96.061 62.8432 96.2545 62.2661C96.7642 60.5201 98.1891 59.4351 99.9693 59.4351C101.402 59.4351 101.96 60.1952 101.96 62.156V69.1961C101.96 70.8693 102.732 71.6518 104.4 71.6518H106.584L106.577 61.3735C106.577 57.2913 104.592 55.1326 100.836 55.1326M86.3265 55.4986H84.1501L84.1649 71.6574H86.4846L86.5665 71.6611L87.6491 71.6574H88.7243V71.6518H88.7318L88.7411 57.9543C88.7411 56.3016 87.9542 55.4986 86.3265 55.4986ZM57.7817 67.9935C55.4825 67.9935 53.8808 66.1597 53.8808 63.5378C53.8808 60.916 55.4806 59.0859 57.7835 59.0859C60.0864 59.0859 61.7122 60.916 61.7122 63.5378C61.7122 66.2008 60.1293 67.9935 57.7817 67.9935ZM57.7817 55.17C52.9117 55.17 49.3773 58.69 49.3773 63.536C49.3773 68.3819 52.9117 71.902 57.7854 71.902C62.6592 71.902 66.2177 68.3838 66.2177 63.536C66.2177 58.6882 62.6833 55.1662 57.7854 55.1662",
    fill: "#273B7D"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_43_3926",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 47,
    width: 177,
    height: 31
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6491 47.9972H190.439V77.9412H14.6491V47.9972Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_43_3926)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_43_3926",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 48,
    width: 177,
    height: 30
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6491 48.5872H190.401V77.9019H14.6491V48.5872Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_43_3926)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_43_3926",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 47,
    width: 177,
    height: 31
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6491 77.9412H190.439V47.9972H14.6491V77.9412Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_43_3926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.127 67.9954C153.828 67.9954 152.224 66.1616 152.224 63.5397C152.224 60.9179 153.828 59.0878 156.127 59.0878C158.437 59.0878 160.058 60.9179 160.058 63.5397C160.058 66.2026 158.476 67.9954 156.127 67.9954ZM156.127 55.1718C151.257 55.1718 147.724 58.6919 147.724 63.5378C147.724 68.3838 151.259 71.9039 156.127 71.9039C161.008 71.9039 164.559 68.3857 164.559 63.5378C164.559 58.69 161.025 55.1681 156.127 55.1681",
    fill: "#499FDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.257 67.2839C113.746 67.2839 112.853 65.0878 112.853 63.0262C112.853 62.1186 113.082 59.1606 116.015 59.1606C117.472 59.1606 119.412 59.5789 119.412 63.1755C119.412 66.5686 117.695 67.2801 116.255 67.2801L116.257 67.2839ZM121.797 55.4594C120.926 55.4594 120.257 55.8086 119.937 56.4454L119.81 56.6919L119.598 56.5051C118.858 55.8628 117.53 55.099 115.375 55.099C111.084 55.099 108.195 58.3352 108.195 63.1475C108.195 67.9599 111.184 71.3193 115.461 71.3193C116.921 71.3193 118.076 70.9757 118.992 70.2811L119.364 70.014V70.4622C119.364 72.6209 117.974 73.8123 115.454 73.8123C114.399 73.7996 113.355 73.6064 112.366 73.2409C111.395 72.9458 110.822 73.1905 110.431 74.1709L110.066 75.0747L109.551 76.3968L109.867 76.5649C111.482 77.4239 113.582 77.9374 115.48 77.9374C119.386 77.9374 123.951 75.93 123.951 70.2811L123.97 55.4594H121.797Z",
    fill: "#273B7D"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_43_3926",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 47,
    width: 177,
    height: 31
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6491 47.9972H190.439V77.9412H14.6491V47.9972Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_43_3926)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_43_3926",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 47,
    width: 177,
    height: 31
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6491 77.9412H190.439V47.9972H14.6491V77.9412Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_43_3926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6573 67.8104L18.922 67.8066V63.3249C18.922 62.365 19.2941 61.8683 20.1088 61.7525H22.6573C24.4747 61.7525 25.6337 62.9028 25.6337 64.7646C25.6318 66.6769 24.4859 67.8085 22.6573 67.8085V67.8104ZM18.922 55.717V54.5368C18.922 53.5041 19.3573 53.013 20.3116 52.9495H22.2239C23.8609 52.9495 24.8281 53.9336 24.8281 55.5826C24.8281 56.8375 24.1547 58.3034 22.2666 58.3034H18.9053L18.922 55.717ZM27.4269 60.1913L26.7516 59.8104L27.3413 59.3062C28.0296 58.7142 29.1755 57.3827 29.1755 55.0858C29.1755 51.5676 26.4596 49.2968 22.2555 49.2968H16.9093C16.3078 49.3189 15.7376 49.5724 15.3172 50.0049C14.8968 50.4374 14.6582 51.0156 14.6509 51.6199V71.5826H22.3522C27.0269 71.5826 30.0442 69.0279 30.0442 65.0709C30.0442 62.942 29.0694 61.1194 27.4305 60.1932",
    fill: "#273B7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.057 55.1904C184.11 55.1939 183.175 55.411 182.323 55.8257C181.47 56.2404 180.721 56.8421 180.131 57.5863L179.8 58.0083L179.54 57.5359C178.688 55.9803 177.226 55.1904 175.193 55.1904C173.059 55.1904 171.628 56.3856 170.964 57.0952L170.529 57.5676L170.343 56.9458C170.101 56.0494 169.307 55.5583 168.105 55.5583H166.176L166.158 71.6554H170.538V64.5499C170.541 63.9154 170.619 63.2834 170.771 62.6675C171.189 60.9495 172.339 59.1008 174.272 59.2875C175.462 59.4033 176.046 60.3277 176.046 62.1129V71.6554H180.459V64.5499C180.442 63.893 180.525 63.2374 180.706 62.6059C181.078 60.9663 182.261 59.2856 184.125 59.2856C185.476 59.2856 185.974 60.0513 185.974 62.1129V69.3025C185.974 70.9271 186.696 71.6554 188.318 71.6554H190.379L190.383 61.379C190.383 57.2707 188.582 55.1904 185.04 55.1904M145.169 66.0662C145.156 66.0849 143.271 68.0774 140.788 68.0774C138.526 68.0774 136.242 66.6843 136.242 63.577C136.242 60.8916 138.013 59.0149 140.55 59.0149C141.372 59.0149 142.31 59.3099 142.457 59.8085L142.475 59.8926C142.569 60.2358 142.773 60.5384 143.055 60.7535C143.338 60.9686 143.683 61.0841 144.038 61.0821L146.456 61.0858V58.9794C146.456 56.2007 142.935 55.1923 140.567 55.1923C135.499 55.1923 131.824 58.7329 131.824 63.6106C131.824 68.4883 135.458 72.0214 140.474 72.0214C144.823 72.0214 147.17 69.1512 147.211 69.1232L147.338 68.9663L145.437 65.8011L145.185 66.0681",
    fill: "#499FDD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.73b8d10a97e3253fd1a3b7e67265195a.svg";
export { ForwardRef as ReactComponent };